<template>
    <div>
        <div v-if="isPlatform">
            <app-implement-measurements-platform-view
                :culture-practice-selected="culturePracticeSelected"
                :connector-type-selected="connectorTypeSelected"
                :measurements="measurements"/>
        </div>
        <div v-else>
            <app-implement-measurements-implement-view
                :culture-practice-selected="culturePracticeSelected"
                :connector-type-selected="connectorTypeSelected"
                :measurements="measurements"/>
        </div>
    </div>
</template>

<script>
import AppImplementMeasurementsPlatformView from "@/components/views/implements/AppImplementMeasurementsPlatformView";
import AppImplementMeasurementsImplementView from "@/components/views/implements/AppImplementMeasurementsImplementView";
export default {
    props: {
        isPlatform: {
            type: Boolean,
            default: true
        },
        connectorTypeSelected: {
            type: Object,
            required: true
        },
        culturePracticeSelected: {
            type: Object,
            required: true
        },
        measurements: {
            type: Object,
            required: true
        }
    },
    components: {
        AppImplementMeasurementsPlatformView,
        AppImplementMeasurementsImplementView
    }
}
</script>

<style scoped>
</style>
